<div class="report-select">
    <select
        class="form-control"
        hznTestId="reports-type-select"
        [(ngModel)]="selectedType"
        (change)="onReportTypeChanged()"
    >
        @for (t of types; track t) {
            <option [ngValue]="t.value">{{ t.displayName }}</option>
        }
    </select>
</div>
